// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"72ad94e3","703":"de7fb6d1","787":"6f55e6d6"}[chunkId] + ".chunk.js";
};